/**
 * Copyright © 2026 Delicious AI, LLC
 *
 * FirebaseUI ships hard-coded light colors (#fff card, dark text). These overrides
 * follow the active MUI theme so email/password sign-in matches light/dark mode.
 */

import { css, Global } from '@emotion/react'
import { alpha, useTheme } from '@mui/material/styles'

const FirebaseUiThemeStyles = () => {
  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark'
  const inputBackground = isDark
    ? alpha(theme.palette.common.white, 0.06)
    : theme.palette.background.paper
  const inputBorder = isDark
    ? alpha(theme.palette.common.white, 0.23)
    : '#e0e0e0'

  return (
    <Global
      styles={css`
        .dai-firebase
          .firebaseui-container:not(.firebaseui-page-provider-sign-in):not(
            .firebaseui-id-page-callback
          ),
        .dai-firebase .firebaseui-container.mdl-card,
        .dai-firebase .mdl-card {
          background-color: transparent !important;
          color: ${theme.palette.text.primary} !important;
          box-shadow: none !important;
        }

        .dai-firebase .firebaseui-title,
        .dai-firebase .firebaseui-subtitle,
        .dai-firebase .firebaseui-text {
          color: ${theme.palette.text.primary} !important;
        }

        .dai-firebase .firebaseui-label,
        .dai-firebase div.firebaseui-textfield > label,
        .dai-firebase
          .mdl-textfield--floating-label.is-dirty
          .mdl-textfield__label,
        .dai-firebase
          .mdl-textfield--floating-label.is-focused
          .mdl-textfield__label {
          color: ${theme.palette.text.secondary} !important;
        }

        .dai-firebase .firebaseui-input,
        .dai-firebase input.firebaseui-input,
        .dai-firebase div.firebaseui-textfield > input {
          color: ${theme.palette.text.primary} !important;
          background-color: ${inputBackground} !important;
          border-color: ${inputBorder} !important;
        }

        .dai-firebase .firebaseui-tos,
        .dai-firebase .firebaseui-id-resend-countdown {
          color: ${theme.palette.text.secondary} !important;
        }
      `}
    />
  )
}

export default FirebaseUiThemeStyles
